//*Libraries imports
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";

//*Icons Imports
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

//*Components Imports
import CustomModal from "components/CustomModal";

const style = {
  position: "fixed",
  width: "100vw",
  height: "100vh",
  backgroundColor: "var(--background-color1)",
  color: "var(--text-color0)",
  fontSize: "1.4rem",
  top: "0",
};

function VerticalItems({
  openMenu,
  setOpenMenu,
  nav_links,
  scrollTo,
  styles,
  logo_white,
  logo_black,
  dark_mode,
}) {
  const navigate = useNavigate();

  return (
    <CustomModal
      id="vertical-menu-modal"
      data-testid="vertical-menu-modal"
      aria-label="Menu Mobile"
      style={style}
      visible={openMenu}
    >
      <div
        id="vertical-menu-container"
        data-testid="vertical-menu-container"
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "2rem",
          gap: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            marginBottom: "2rem",
            justifyContent: "space-between",
          }}
        >
          <a href="/" id="logo-link-mobile" data-testid="logo-link-mobile" aria-label="Voltar para Home">
            <img
              className={"Transition-1"}
              src={`${dark_mode ? logo_black : logo_white}?v=1.1`}
              alt="Logotipo da IGooB"
              style={{
                width: "10rem",
              }}
            />
          </a>

          <CloseRoundedIcon
            id="close-menu-button"
            data-testid="close-menu-button"
            aria-label="Fechar menu"
            onClick={() => setOpenMenu(false)}
            style={{
              cursor: "pointer",
              fontSize: "2.4rem",
            }}
          />
        </div>
        {nav_links.map((item, index) => (
          <div className={styles.navItemsWrapper} key={index}>
            <Box
              id={`nav-item-mobile-${index}`}
              data-testid={`nav-item-mobile-${index}`}
              aria-label={`Ir para ${item.name}`}
              className="Transition-1"
              onClick={() => {
                setOpenMenu(false);
                if (item.element_id) {
                  scrollTo(item.element_id);
                } else {
                  navigate(item.link, { replace: true });
                }
              }}
              sx={{
                cursor: "pointer",
                color: "var(--text-color0)",
                fontWeight: "normal",
                padding: "0.4rem",
                gap: "1rem",
                display: "flex",
                whiteSpace: "nowrap",
                alignItems: "center",
                "&:hover": {
                  color: "var(--text-color0)",
                  transition: "color 0.3s",
                },
                "&:after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "2px",
                  bottom: "0",
                  left: "0",
                  backgroundColor: "var(--text-color0)",
                  transform: "scaleX(0)",
                  transformOrigin: "bottom right",
                  transition: "transform 0.3s",
                },
                "&:hover:after": {
                  transform: "scaleX(1)",
                  transformOrigin: "bottom left",
                },
              }}
            >
              <item.icon
                style={{
                  fontSize: "1.8rem",
                }}
              />
              {item.name}
            </Box>
          </div>
        ))}
      </div>
    </CustomModal>
  );
}

export default VerticalItems;
